import { actionTypes } from "../actions/channels";

const variable = (state = null, action) => {
  switch (action.type) {
    case actionTypes.FETCH_CHANNEL:
      return action.payload;
    default:
      return state;
  }
};

export default variable;